import React from "react";
import Helmet from "react-helmet";
import Hero from "../components/hero";
import Layout from "../components/layouts/chuzo-week";
import Column from "../components/layout/column";
import { graphql } from "gatsby";
import styled from 'styled-components'
import Wrapper from '../components/layout/Wrapper'
import breakpoint from 'styled-components-breakpoint'
import Solicite from '../../static/images/chuzo-week/asset-2.svg'
import Cuatro from '../../static/images/chuzo-week/asset-3.svg'
import Cinco from '../../static/images/chuzo-week/asset-4.svg'


const Contenedor = styled(Wrapper)`
  padding-top: 20px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  text-align: center;

  ${breakpoint('tablet')`
    text-align: left;
    flex-direction: row;
    align-items: center;
  `}

  ${breakpoint('desktop')`
    padding-top: 40px;
    margin-bottom: 60px;
  `}

  .heightAuto {
    
    ${breakpoint('tablet')`
        height: 315px;
    `}
  }

  .fontSizeAuto {
    font-size: 19px;
    ${breakpoint('tablet')`
        font-size: 23px !important;
    `}
  }
  
`

const Div = styled.div`
    margin-bottom: 50px;
      height: 100px;

     & p {
         font-size:18px;
         text-align:center;
         
     }

     & img {
         margin:0 auto;
         display:block;
     }

     ${breakpoint('tablet')`
        
        & p {
            text-align: justify;
            
        }
    `}

`


const Icono1 = styled.img`
    width:120px;
    margin:50px auto;
`
const Titulo = styled.div `
    width:100%;

    & p {
        font-size: 18px;
        text-align:center;
    }

    & h3 {
        font-size: 22px;
        text-align: center;
    }

    ${breakpoint('tablet') `
        
        & p {
            font-size: 30px;
        }
    `}
}
`

const TitleLine2 = styled.h1 `
    display:inline-block;
    text-align:center;
    position:relative;
    width: 100%;
    font-size: 23px;
    font-weight: 900;
    margin-bottom: 20px;

    ${breakpoint('tablet') `
        font-size:30px;

        & ::after, ::before {
            content:'';
            position:absolute;
            width:30% !important;
            height:2px;
            background:gray;
            top:0.6em;
        }
        
        
        &::after {
            left:65px;
            width:30% !important;
        }
    
        &::before {
            right:65px;
            width:30% !important;
        }
    `}
    
    & ::after, ::before {
        content:'';
        position:absolute;
        width:18%;
        height:2px;
        background:gray;
        top:0.6em;
    }
    & ::after {
        left: -7px;
    }

    & ::before {
        right: -7px;
    }
   
`

const Movil3 = styled.div `

    & p {
      font-size: 17px;
      padding: 6px 18px;
    }
    & div {
        display:inline-block;
    }
    & img {
      width: auto !important;
      height: 80px !important;
    }

    & h3 {
      font-size: 29px;
      font-weight: 600;
    }

    & a {
      padding: 10px 40px !important;
      font-size: 15px !important;
      width: 100%;
      height: 47px !important;
      margin-top: 23px !important;
      ${breakpoint('tablet') `
        height: 53px !important;
        font-size: 20px !important;
      `}
    }
    ${breakpoint('tablet') `
        
    & div {
            display: inline-grid;
    }
`}

`

const ButtonBan = styled.a `
    margin: 0 auto;
    background: ${props => props.theme.colors.rojoBac};
    padding: 4px 0px;
    font-size: 16px;
    color: #fff;
    font-weight: 600;
    margin-bottom: 0;
    width: 150px;
    height: 34px;
    text-align: center;
    &:hover {
      text-decoration:none !important;
      color:white !important;
  }
`

const ContentLine = styled.div `
        border: 2px solid #ccc;
        padding: 26px 15px;
        margin-bottom:30px;
        width: 90%;
        margin: 0 auto;
        margin-top: 20px;
        border-radius:5px;
        ${breakpoint('tablet') `
        width: 100%;
    `}

    & img {
        width: 60px !important;
        height: 60px !important;
        margin: 0 auto;
        margin-bottom: 16px;
    }

    & p {
      text-align: center;
    }

    & h3 {
      font-size: 26px;
      ${breakpoint('tablet') `
      font-size: 26px;
    `}
    }
`

const IconoP = styled.img `
    width:80px !important;
    height:auto !important;
`


class hipote extends React.Component {
  render() {
    const { multicanalidad, pais } = this.props.data;
    const { frontmatter } = this.props.data.page;
    const footer = this.props.data.footer
      ? this.props.data.footer.edges.map(f => f.node)
      : null;
    const {
      title,
      description,
      hero,
      utm,
      formUrl,
      heroImage,
      heroSubtitular,
      cta,
      crazyegg
    } = frontmatter;

    const isCostaRica = pais.title === "Costa Rica";

    return (
      <Layout
        {...{ pais }}
        footer={footer}
        multicanalidad={pais.title === "Costa Rica" && multicanalidad != null}
      >
        <Helmet
          title={title}
          meta={[{ name: "description", content: description }]}
        >
          {crazyegg === false ? null : (
            <script
              type="text/javascript"
              src="//script.crazyegg.com/pages/scripts/0083/4677.js"
              async="async"
            />
          )}
        </Helmet>
        {hero && (
          <Hero
            hero={hero}
            utm={utm || null}
            formUrl={formUrl || null}
            location={this.props.location}
            title={title}
            cta={cta}
            heroImage={heroImage}
            heroSubtitular={heroSubtitular}
            multicanalidad={isCostaRica ? multicanalidad : null}
            {...{ pais }}
          />
        )}

        <Contenedor style = {{marginBottom: 20, margintop: 30}} className="animated fadeInDownBig delay-2s">
            <Titulo>
              <Div><Icono1 alt="Solicitá tu Cuenta" src={Solicite}></Icono1></Div>
              <TitleLine2>¿Qué es?</TitleLine2>
              <h3 style={{fontWeight:800}}><strong>Chuzo Week es la primera feria digital para comprar vehículo en Costa Rica</strong></h3>
              <h3 style={{fontWeight:400}}>y en alianza con crautos.com te traemos condiciones especiales y atención personalizada para comprar el carro que querés </h3>
            </Titulo>
        </Contenedor>
            <Contenedor style = {{marginBottom: -30}}>
              <Titulo>
                <TitleLine2 className="fontSizeAuto">¿Qué tenés que hacer?</TitleLine2>
              </Titulo>
            </Contenedor>
        <Contenedor style = {{display:'block'}}> 
              <Movil3>
                <Column division={{ mobile: 1, tablet: 2, desktop: 2 }}
                    rowSpacing={0}>
                    <ContentLine className="heightAuto">
                        <div><IconoP alt="Indicá la tarjeta" src={Cuatro}></IconoP></div>
                        <p style={{marginBottom: 20}}>Si ya tenés idea de cuál es el carro que querés</p>
                        <ButtonBan href="https://www.baccredomatic.com/es-cr/prestamos/vehiculos/nuevo/solicitud?utm_source=form2&utm_medium=clic&utm_campaign=cr_chuzoweek_112019">Solicitá tu crédito aquí</ButtonBan>
                    </ContentLine>
                </Column>
                <Column division={{ mobile: 1, tablet: 2, desktop: 2 }}
                    rowSpacing={0}>
                    <ContentLine>
                        <div><IconoP alt="Indicá la tarjeta" src={Cinco}></IconoP></div>
                        <p style={{marginBottom: 20}}>Si aún no te decidís, entrá en crautos.com y todos los vehículos que tengan el logo de BAC Credomatic aplican para financiamiento</p>
                        <ButtonBan href="http://www.crautos.com/?utm_source=catalogo&utm_medium=clic&utm_campaign=cr_chuzoweek_112019">Ingresá aquí</ButtonBan>
                    </ContentLine>
                </Column>
              </Movil3>
        </Contenedor> 
      </Layout>
    );
  }
}

export const query = graphql`
  query($collection: String, $pais: String!, $path: String!) {
    page: markdownRemark(frontmatter: { path: { eq: $path } }) {
      frontmatter {
        title
        description
        hero
        utm
        formUrl
        cta
        heroImage
        heroSubtitular
        whatsapp
        multicanalidad
        crazyegg
      }
    }

    multicanalidad: contentfulMulticanalidadLinks(
      identificador: { eq: "multicanalidad-tarjetas-cr" }
    ) {
      formLlamada
      telefono
      whatsapp
      form
    }

    allContentfulCategorias(filter: { pais: { glob: $pais } }) {
      edges {
        node {
          id
          titulo
          slug
          orden
          icono {
            file {
              url
              fileName
              contentType
            }
          }
        }
      }
    }

    tarjetas: allContentfulProducto(
      filter: { pais: { title: { eq: $pais } } }
    ) {
      edges {
        node {
          id
          titulo
          productPage
          formOpa
          categorias {
            titulo
            id
          }
          reglamento
          beneficiosGenerales {
            id
            titulo
          }
          variacion {
            titulo
            costo
            tipoDeCosto
            monedaDeCosto
            arte {
              sizes {
                base64
                aspectRatio
                src
                srcSet
                sizes
              }
              id
              title
              file {
                url
                fileName
                contentType
              }
            }
            color {
              titulo
              salarioMinimo
            }
          }
        }
      }
    }

    coleccion: contentfulColecciones(titulo: { eq: $collection }) {
      displayTitle
      description
      productos {
        id
        titulo
        productPage
        formOpa
        reglamento
        categorias {
          titulo
          id
        }
        beneficiosGenerales {
          id
          titulo
        }
        variacion {
          titulo
          costo
          tipoDeCosto
          monedaDeCosto
          arte {
            sizes {
              base64
              aspectRatio
              src
              srcSet
              sizes
            }
            id
            title
            file {
              url
              fileName
              contentType
            }
          }
          color {
            titulo
            salarioMinimo
          }
        }
      }
    }

    tasasDeInteres: allContentfulTasasDeInteres {
      edges {
        node {
          id
          titulo
          preferencialColones
          preferencialDolares
          normalColones
          normalDolares
          orden
        }
      }
    }

    pais: contentfulPais(title: { eq: $pais }) {
      title
      contryAbr
      countrySlug
    }

    footer: allContentfulFooter(filter: { pais: { eq: $pais } }) {
      edges {
        node {
          id
          type
          texto {
            texto
          }
        }
      }
    }
  }
`;

export default hipote;
